import React, { useState } from "react";
import "./faq.css";
import Navbar from "../../common/navBar/navBar.tsx";
import Footer from "../../common/footer/footer.tsx";

const faqData = [
  {
    question: "Does It Cost Anything To Register?",
    answer:
      "No, registration is completely FREE. You can create your profile, upload photos, and browse profiles without any cost.",
  },
  {
    question: "How Do I Know The Profiles Are Authentic?",
    answer:
      "We conduct thorough verification of all profiles. However, we recommend users exercise caution and follow our Safety Tips when interacting with potential matches.",
  },
  {
    question: "Will My Personal Information Be Private?",
    answer:
      "Absolutely. Your personal details remain secure and visible only to approved members. For more details, please refer to our Privacy Policy.",
  },
  {
    question: "How do I express interest in a profile?",
    answer:
      "When you find a profile that matches your preferences, click on the Send Interest button. The member will receive a notification and can choose to accept or decline your interest.",
  },
  {
    question: "How do I get more information about a matched profile?",
    answer:
      "Once you find a profile that matches your preferences, please contact us through the Contact Us section on the Home page. Our team will review your request and share further details about the selected profile after verification.",
  },
];

const FAQ = ({ showNavbar = true }: { showNavbar?: boolean }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {showNavbar && <Navbar />}

      <div className='faq-page'>
        {/* FLOATING HEARTS */}
        <div className='faq-hearts-bg'>
          {Array.from({ length: 18 }).map((_, i) => (
            <span key={i} className='faq-heart'>
              ❤
            </span>
          ))}
        </div>

        {/* HERO */}
        <section className='faq-hero'>
          <h1>Frequently Asked Questions</h1>

          <p>Everything you need to know about our trusted matrimony platform</p>
        </section>

        {/* FAQ */}
        <div className='faq-wrapper'>
          {faqData.map((faq, index) => (
            <div className='faq-item' key={index}>
              <button className='faq-question' onClick={() => toggleFAQ(index)}>
                {faq.question}

                <span className='faq-icon'>{activeIndex === index ? "−" : "+"}</span>
              </button>

              {activeIndex === index && (
                <div className='faq-answer'>
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {showNavbar && <Footer />}
    </>
  );
};

export default FAQ;
